import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useMemo } from 'react';

/**
 * Hook for handling global loading state
 * Tracks both query fetching and mutation states
 * @returns boolean indicating if any data fetching or mutation is in progress
 */
export default function useLoadingHandler(): boolean {
  // #region Queries
  const fetching = useIsFetching({
    predicate: (query) =>
      query.state.status === 'loading' &&
      query.state.dataUpdateCount === 0 &&
      (query.meta?.shouldShowLoading ?? true),
  });
  // #endregion

  // #region Mutations
  const mutating = useIsMutating({
    predicate: (mutation) => mutation.meta?.shouldShowLoading ?? true,
  });
  // #endregion

  // #region Computed Values
  return useMemo(() => !!fetching || !!mutating, [fetching, mutating]);
  // #endregion
}
